import styled from 'styled-components'

import TextField from '../../TextField'

const StyledTextField = styled(TextField)`
  ${props => props.disabled && `opacity: 0.5;`};
`

export default StyledTextField
